import {
  createContext,
  FC,
  PropsWithChildren,
  useEffect,
  useState,
} from 'react';
import { deleteBlacklist, getBlacklist } from '../services';
import useUser from '../../../hooks/useUser';
import Blacklist from '../interfaces/Blacklist';
import CustomerGroupContext from '../interfaces/BlacklistContext';
import toast from 'react-hot-toast';
import { useTranslations } from 'use-intl';

export const BlacklistManagementContext = createContext<CustomerGroupContext>({
  blacklist: [],
  loading: false,
  error: null,
  open: false,
  setBlacklist: () => {},
  deleteBlacklist: (id) => {
    return Promise.resolve();
  },
  setOpen: () => {}
});

export const BlacklistManagementProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const t = useTranslations('blacklistManagement');
  const { selectedBusiness } = useUser();
  const [blacklist, setBlacklist] = useState<Blacklist[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<null | string>(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getBlacklist(selectedBusiness.name)
      .then((res) => setBlacklist(res))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [selectedBusiness]);

  const handleDeleteBlacklist = (id: number) => {
    return deleteBlacklist(id, selectedBusiness.name).then(() => {
      toast.success(t('groupDeleted'));
      setBlacklist((blacklist) =>
        blacklist.filter((customerGroup) => customerGroup.id !== id)
      );
    });
  };

  return (
    <BlacklistManagementContext.Provider
      value={{
        blacklist,
        loading,
        error,
        open,
        setBlacklist,
        deleteBlacklist: handleDeleteBlacklist,
        setOpen,
      }}
    >
      {children}
    </BlacklistManagementContext.Provider>
  );
};
export default BlacklistManagementContext;
